// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__28-9R"};